<template>
  <v-layout>
    <v-flex md12>
      <v-card>
        <v-card-title style="background-color: teal" class="white--text">
          <h1 class="display-1">
            {{ english ? "Manifests Overview" : "Aperçu des Manifestes" }}
          </h1>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout>
            <v-flex md3>
              <v-card color="gray" height="100%" tile>
                <v-card-title class="title">
                  <span color="secondary">{{
                    english
                      ? "Manifest Date Range"
                      : "Manifeste Par Plage De Date"
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <DatePicker />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3>
              <v-card color="secondary" class="white--text" height="100%" tile>
                <v-card-title>
                  <h2>
                    {{ english ? "Serviced Manifests" : "Manifestes Traités" }}
                  </h2>
                </v-card-title>
                <v-card-text>
                  <h3 class="display-1">{{ totalManifests }}</h3>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3>
              <v-card
                color="teal lighten-2"
                class="white--text"
                height="100%"
                tile
              >
                <v-card-title>
                  <h2>
                    {{
                      english ? "Available Manifests" : "Manifestes Disponible"
                    }}
                  </h2>
                </v-card-title>
                <v-card-text>
                  <h3 class="display-1">{{ manifestsAvailable }}</h3>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3>
              <v-card color="secondary" class="white--text" height="100%" tile>
                <v-card-title>
                  <h2>
                    {{
                      english
                        ? "Unavailable Manifests"
                        : "Manifestes Non-Disponible"
                    }}
                  </h2>
                </v-card-title>
                <v-card-text>
                  <h3 class="display-1">{{ manifestsUnavailable }}</h3>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";

import DatePicker from "@/components/services/DatePicker";

export default {
  data() {
    return {
      currentYear: moment().format("YYYY"),
    };
  },
  components: { DatePicker },
  computed: {
    ...mapState([
      "dateToManifest",
      "dateFromManifest",
      "manifestsAvailable",
      "manifestsUnavailable",
      "totalManifests",
      "english",
    ]),
    getUserCountry() {
      return this.$store.state.userCountry;
    },
    getCustNum() {
      return this.$store.state.cust;
    },
  },
  methods: {
    ...mapActions([
      "LOAD_CUST_MANIFEST_AVAILABILITY",
      "LOAD_CUST_TOTAL_MANIFESTS",
    ]),
  },
  mounted() {
    this.LOAD_CUST_MANIFEST_AVAILABILITY();
    this.LOAD_CUST_TOTAL_MANIFESTS();
  },
};
</script>

<style>
.selectedView {
  border: 0.2em solid #fff !important;
}
</style>
